import React from 'react'
import SelectBox from '../components/SelectBox'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { changeCustomerAction, changeLangAction, logout } from '../actions/Actions'
import { Message } from '../locale/Message'
import { Link, withRouter } from "react-router-dom"
import { capitalizeText } from '../Utils'

class Header extends React.Component {

  changeCustomer = (value) => {
    const { changeCustomer, userInfo } = this.props
    changeCustomer(userInfo.assignCustomers.filter(it => it.bin === value)[0])
  }

  renderLangSelectBox = ({ lang, changeLang }) =>
  (
    <SelectBox
      sectionClassName="d-inline-block position-relative ml-4"
      value={lang}
      header={Message.selectLang[lang]}
      ulClassName="t-light mb-0 selectbox lang-switcher bg-white text-midnight-gray"
      spanClassName="selectbox-title text-left cursor-pointer"
      data={[
        { name: 'РУС', value: 'ru' },
        { name: 'ENG', value: 'en' },
        { name: 'ҚАЗ', value: 'kk' }
      ]}
      onSelect={changeLang}
    />
  )

  renderChangeCustomerSelectBox = ({ customer, userInfo, lang }) => {
    if (!(userInfo && customer && userInfo.assignCustomers)) {
      return null
    }
    const customers = userInfo.assignCustomers
    return customers[0] && (
      <SelectBox
        value={customer.bin}
        sectionClassName="d-inline-block position-relative pr-2 profile-name"
        header={Message.selectCompany[lang]}
        ulClassName="t-light mb-0 selectbox left bg-white text-midnight-gray"
        spanClassName="selectbox-title text-left cursor-pointer"
        data={
          customers.map((it) => ({
            name: it.alias || Message.bin[lang] + it.bin,
            value: it.bin
          }))
        }
        onSelect={this.changeCustomer}
      />
    )
  }

  renderUserMenu = ({ userInfo, lang, idToken }) => userInfo &&
    (
      <SelectBox
        sectionClassName="d-inline-block cursor-pointer profile-btn"
        ulClassName="t-light mb-0 selectbox bg-white text-midnight-gray profile-option-selectbox"
        header={
          <div className="d-flex">
            <div className="icon bg-purple text-white">
              {userInfo.firstName && userInfo.firstName.charAt(0)}
            </div>
            {userInfo.firstName} {userInfo.lastName}
          </div>
        }
        data={[
          {
            name: Message.myProfile[lang], value: 1
          }, 
          {
            name: Message.exit[lang], value: 2
          }]}
        onSelect={(value) => {
          switch (value) {
            case 1:
              this.props.history.push('/settings')
              break
            case 2:
              logout(idToken)
              break
          }
        }}
      >
        <div
          className="profile-icon bg-white rounded-circle text-purple text-center d-inline-block">
          {userInfo.firstName && userInfo.firstName.charAt(0)}
        </div>
        <div className="profile-option bg-white rounded-circle text-purple text-center">
          <i className="fa fa-angle-down" />
        </div>
      </SelectBox>
    )

  renderServiceMenu({ customer, lang }) {
    if (!customer || !customer.clientServices || customer.clientServices.length === 0) {
      return null
    }
    const services = customer.clientServices.filter(
      (item) => item.alias !== 'msg' && item.alias !== 'b2b_fwa_selfcare'
    )
    return (
      <div className="d-inline-block ml-lg-5">

        <SelectBox
          sectionClassName="position-relative ml-4 d-none d-lg-inline-block"
          header={Message.chooseService[lang]}
          spanClassName="selectbox-title text-left cursor-pointer menu align-middle"
          ulClassName="t-light mb-0 selectbox bg-white text-midnight-gray"
          data={
            services.map(service => ({
              name: service[`name${capitalizeText(lang)}`],
              value: service.url
            }))
          }
          defaultName={Message.chooseService[lang]}
          onSelect={(value) => document.location = value}
        />

        <nav className="d-inline-block align-middle d-lg-none">
          <input type="checkbox" id="nav" className="d-none" />
          <label htmlFor="nav" className="nav-open">
            <i className="bg-white" />
            <i className="bg-white" />
            <i className="bg-white" />
          </label>
          <div className="nav-container clearfix bg-purple">
            <div class="d-flex align-items-center p-3 nav-header">
              <a class="d-inline-block" href="/">
                <img
                  className="logo d-lg-none"
                  src="/kcell-white.svg"
                  width={50}
                />
              </a>
            </div>
            <ul className="mb-0 pl-0 menu">
              {
                services
                  .map(
                    (service, index) => (
                      <li className="d-inline-block" key={index}>
                        <a href={service.url}>{service[`name${capitalizeText(lang)}`]}</a>
                      </li>
                    )
                  )
              }
            </ul>
          </div>
        </nav>
      </div>
    )
  }

  redirectToMainPage = () => { document.location = "/" }

  render() {
    const { lang } = this.props
    return (
      <header className="global-header bg-purple">
        <div className="d-flex justify-content-between top p-3">
          <Link to="/">
            <img
              className="logo d-lg-none"
              src="/kcell-white.svg"
              width={50}
            />
          </Link>
          <div>
            {this.renderServiceMenu(this.props)}

            {this.renderUserMenu(this.props)}
          </div>
        </div>

        <div className="d-flex justify-content-between p-3">
          {this.renderChangeCustomerSelectBox(this.props)}

          {this.renderLangSelectBox(this.props)}
        </div>
      </header>
    )
  }

}

export default connect(
  state => ({
    lang: state.lang,
    idToken: state.idToken,
    userInfo: state.userInfo,
    customer: state.customer
  }),
  dispatch => ({
    changeCustomer: bindActionCreators(changeCustomerAction, dispatch),
    changeLang: bindActionCreators(changeLangAction, dispatch)
  })
)(withRouter(Header))